/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { AbstractGenFirestoreService } from '@res/ngg-core';

import { OrmService, Schema } from '../schema/schema.interface';

@Injectable({
  providedIn: 'root',
  deps: [],
})
export class PartnerFirestoreService extends AbstractGenFirestoreService<Schema, 'partners'> {
  constructor() {
    super(inject(OrmService).parnerCollection);
  }
}
